{
  "reports": {
    "filterLabels": {
      "branch": "Purchasing unit",
      "region": "Region",
      "category": "Category",
      "supplier": "Supplier",
      "budgetPeriod": "Budget period",
      "open": "Open records",
      "late": "Late records",
      "overdue": "Overdue records",
      "issued": "Issued orders",
      "exclude_cancelled": "Cancelled orders",
      "awarded": "Awarded enquiries",
      "no_award": "Enquiries closed without award",
      "decided": "Decided enquiries (cycle time)",
      "currency": "Currency",
      "attribution": "Attribution",
      "attributedCategory": "Attributed to a category",
      "unattributedCategory": "Unattributed — mixed or missing category",
      "categoryAndUnattributed": "{{categories}}, plus all of {{unattributed}}",
      "only": "Only",
      "excluded": "Excluded"
    },
    "budgetOutcome": {
      "released": "Reservation released",
      "held": "Still held",
      "reserved": "Reserved for this request",
      "givenBack": "Given back to the budget",
      "stillHeld": "Still held by this request",
      "note": "This request is over, so it no longer deducts from this budget. These are the amounts the budget ledger recorded for it."
    }
  }
}
